import { render, staticRenderFns } from "./NpaView.vue?vue&type=template&id=486194a9&scoped=true"
import script from "./NpaView.vue?vue&type=script&lang=js"
export * from "./NpaView.vue?vue&type=script&lang=js"
import style0 from "./NpaView.vue?vue&type=style&index=0&id=486194a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486194a9",
  null
  
)

export default component.exports